"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { FaApple, FaCheck, FaGooglePlay } from "react-icons/fa";
import "swiper/css";
import "swiper/css/free-mode";
import BusinessModelCard from "@/components/product/BusinessModelCard";
import OrderingAppSection from "@/components/product/OrderingAppSection";
import FeatureCard from "@/components/product/FeatureCard";
import PortfolioCard, { PortfolioProject } from "@/components/ourWork/PortfolioCard";
import PortfolioStack from "@/components/ourWork/PortfolioStack";
import ContactSection from "@/components/common/ContactSection";
import ClientsSection from "@/components/ClientsSection";
import { FeaturedCarousel } from "@/components/Hero";
import { motion } from "framer-motion";
import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { DESKTOP_QUERY } from "@/lib/breakpoints";
import { useGsapStaggerAnimation } from "@/hooks/useGsapStaggerAnimation";
import GradientButton from "@/components/ui/GradientButton";
const EASE: [number, number, number, number] = [0.25, 0.1, 0.25, 1];
const featuredBrands = [{
  name: "VoyageATL",
  className: "font-serif italic font-semibold text-slate-500"
}, {
  name: <>
        Inc<span className="text-pink-500">42</span>
      </>,
  className: "font-black text-slate-700"
}, {
  name: "Forbes",
  className: "font-serif font-bold text-slate-700"
}, {
  name: "BISNOW",
  className: "font-black text-slate-800"
}];
const businessModels = [{
  id: 1,
  icon: "/images/products/startup.svg",
  title: "Grocery Delivery startup",
  description: "Streamline your startup or offline outlet to online with grocery delivery."
}, {
  id: 2,
  icon: "/images/products/grossary.svg",
  title: "Grocery Marketplace",
  description: "Spread your business via connecting it to all the nearby stores."
}, {
  id: 3,
  icon: "/images/products/chain.svg",
  title: "Grocery Chain",
  description: "Organize multiple grocery stores through a single online delivery console."
}];
const clientLogos = [{
  id: 1,
  image: "/images/products/logo-pajasaagro.png",
  alt: "Fruitbox Fresh"
}, {
  id: 2,
  image: "/images/products/logo-trendfresh.png",
  alt: "Galaxy Maart"
}, {
  id: 3,
  image: "/images/products/logo-wifibasket.png",
  alt: "Veg n More"
}, {
  id: 4,
  image: "/images/products/logo-fairnfine.png",
  alt: "Oshopping Sathi"
}, {
  id: 5,
  image: "/images/products/logo-farm-fresh.png",
  alt: "Oshopping Sathi"
}, {
  id: 6,
  image: "/images/products/logo-freshvatika.png",
  alt: "Pajasa Agro"
}, {
  id: 7,
  image: "/images/products/logo-fruittofresh.png",
  alt: "Trends Fresh"
}, {
  id: 8,
  image: "/images/products/logo-galaxymaart.png",
  alt: "Trends Fresh"
}, {
  id: 9,
  image: "/images/products/logo-megnmore.png",
  alt: "Trends Fresh"
}, {
  id: 10,
  image: "/images/products/logo-oshopping.png",
  alt: "Trends Fresh"
}];
const featureCard = [{
  icon: "/images/products/feature-database.svg",
  title: "5000+ Products Database",
  description: "With 5k+ database, you don’t need to worry about creating them every time. Just fill in when you’re done with the previous one."
}, {
  icon: "/images/products/feature-delivery.svg",
  title: "Custom Delivery",
  description: "Here, customers can select a time-slot as per their availability and get their order delivered at the doorstep at allotted time."
}, {
  icon: "/images/products/feature-customizable.svg",
  title: "Customizable",
  description: "Customize your design with this catchy, custom-made & user-friendly interface that allows users to have a smooth experience."
}, {
  icon: "/images/products/feature-returns.svg",
  title: "Product Returns",
  description: "What if the wrong product is delivered? Customers can always avail the product return policy to return their product."
}, {
  icon: "/images/products/feature-orders.svg",
  title: "Repeat Orders",
  description: "This feature helps the customers to repeat their previous orders with a single click, without any hustle of adding everything all over again."
}, {
  icon: "/images/products/feature-wallet.svg",
  title: "Wallet System",
  description: "The buyer can pay via wallet cash or by linking their debit/credit cards. Admin has access to refund & revise the limit part."
}, {
  icon: "/images/products/feature-refer.svg",
  title: "Refer n Earn System",
  description: "Earn referral points every time you refer to a new user. Admin can customize the points. Increase your traffic & get new users this way."
}, {
  icon: "/images/products/feature-billing.svg",
  title: "Weight Based Billing",
  description: "Admin can split the ordered products as per their weight. The trouble of listing each product as per the category eliminates."
}, {
  icon: "/images/products/feature-modify.svg",
  title: "Modify Customer Orders",
  description: "This feature also favors the admin. They can change and rectify customer’s confirmed orders as per the availability in inventory."
}];
const features = [{
  id: 1,
  icon: "/images/products/feature-experience.png",
  title: "8+ Years of experience in Grocery Solution"
}, {
  id: 2,
  icon: "/images/products/feature-affordable.png",
  title: "Affordable & Personalised plans"
}, {
  id: 3,
  icon: "/images/products/feature-support.png",
  title: "Free 1-year of technical support"
}, {
  id: 4,
  icon: "/images/products/feature-refund.png",
  title: "45 days refund policy"
}, {
  id: 5,
  icon: "/images/products/feature-friendly.png",
  title: "User-friendly UI/UX"
}, {
  id: 6,
  icon: "/images/products/feature-ready.png",
  title: "Ready to launch application"
}];
const platforms = [{
  title: "Responsive\nWebsite",
  bg: "#68d8dd",
  icon: "/images/products/responsive.png"
}, {
  title: "Customer\nWeb Panel",
  bg: "#f6e88b",
  icon: "/images/products/web-panel.png"
}, {
  title: "Vendor\nWeb Panel",
  bg: "#9cf2d7",
  icon: "/images/products/vendorepanel.png"
}, {
  title: "Admin\nWeb Panel",
  bg: "#ffc17c",
  icon: "/images/products/adminpanel.png"
}, {
  title: "Customer App\nfor iPhone",
  bg: "#dcff83",
  icon: "/images/products/iphone.png"
}, {
  title: "Customer App\nfor Android",
  bg: "#f39ac2",
  icon: "/images/products/android.png"
}];
const platformDelays = [0.2, 0.4, 0.6, 0.8, 1, 1.2];
const apiLogos = [{
  name: "Google Maps",
  image: "/images/products/map.png"
}, {
  name: "Google Analytics",
  image: "/images/products/google-analytics.png"
}, {
  name: "Paytm",
  image: "/images/products/paytm.png"
}, {
  name: "Facebook",
  image: "/images/products/facebook-analytics.png"
}, {
  name: "Firebase",
  image: "/images/products/firebase.png"
}, {
  name: "Razorpay",
  image: "/images/products/razorpay.png"
}, {
  name: "Whatsapp",
  image: "/images/products/new-whatsapp.png"
}, {
  name: "MSG91",
  image: "/images/products/msg.png"
}];
const apiLogoDelays = [0.2, 0.4, 0.6, 0.8, 1, 1, 1, 1];
export const portfolioProjects: PortfolioProject[] = [{
  id: 1,
  name: "Pajasa Agro",
  logo: "/images/products/logo-pajasa-agro.png",
  logoAlt: "Pajasa Agro",
  platforms: ["Web", "Android", "iPhone"],
  description: "Pajasa Agro is aimed at delivering fresh fruits and vegetables at your doorstep in Delhi-Dwarka. They are one of the emerging businesses in the field of Agriculture",
  stats: ["4.2 star rating", "7K+ customers", "100+ Daily Orders", "200+ Daily Active Users"],
  desktopImage: "/images/products/portfolio-pajasa-desktop.jpg",
  mobileImage: "/images/products/portfolio-pajasa-mobile.jpg",
  background: "from-[#e8f8d7] to-[#fff0b5]",
  buttonText: "Project Details",
  buttonHref: "/product"
}, {
  id: 2,
  name: "Freshhaat",
  logo: "/images/products/logo-freshhaat.png",
  logoAlt: "Freshhaat",
  platforms: ["Web", "Android", "iPhone"],
  description: "Freshhaat makes online grocery shopping fast and easy. Get groceries delivered and order the best of seasonal farm fresh food.",
  stats: ["4.5 star rating", "10K+ App installs", "2K+ Registered Vendors", "5K+ Daily Bill Payments"],
  desktopImage: "/images/products/portfolio-freshhaat-desktop.jpg",
  mobileImage: "/images/products/portfolio-freshhaat-mobile.jpg",
  background: "from-[#e0f7e9] to-[#d9f3e7]",
  buttonText: "Project Details",
  buttonHref: "/product"
}, {
  id: 3,
  name: "GroDoor",
  logo: "/images/products/logo-grodoor.png",
  logoAlt: "GroDoor",
  platforms: ["Web", "Android", "iPhone"],
  description: "We provide super fast delivery service, and you just have to wait while sitting at home. Let’s use our services right now and get discounts of up to 50%.",
  stats: ["Product Strategy", "Product UI/UX Design", "Branding Design", "Design System"],
  desktopImage: "/images/products/portfolio-grodoor-desktop.jpg",
  mobileImage: "/images/products/portfolio-grodoor-mobile.jpg",
  background: "from-[#ffe2d7] to-[#ffd9ca]",
  buttonText: "Project Details",
  buttonHref: "/product"
}, {
  id: 4,
  name: "R-Project",
  logo: "/images/products/logo-reekayafresh.png",
  logoAlt: "R Project",
  platforms: ["Web", "Android"],
  description: "Reekaya Fresh’s mission is to offer nutritious produce and promote good, healthy eating habits. And while doing so, the brand believes in doing its bit towards a healthier society.",
  stats: ["Product Strategy", "Product UI/UX Design", "Branding Design", "Design System"],
  desktopImage: "/images/products/portfolio-reekayafresh-desktop.jpg",
  mobileImage: "/images/products/portfolio-reekayafresh-mobile.jpg",
  background: "from-[#d9f5e8] to-[#d8f0df]",
  buttonText: "Project Details",
  buttonHref: "/product"
}];
export default function HeroSection() {
  const $ = _c(145);
  const desktopAnimations = useDesktopAnimations();
  const appSectionRef = useRef(null);
  const leftScreenRef = useRef(null);
  const rightScreenRef = useRef(null);
  const categoryRef = useRef(null);
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const titleRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const media = gsap.matchMedia();
      media.add(`${DESKTOP_QUERY} and (prefers-reduced-motion: no-preference)`, () => {
        const tl = gsap.timeline({
          defaults: {
            duration: 1.2,
            ease: "power3.out"
          }
        });
        tl.fromTo(leftScreenRef.current, {
          opacity: 0,
          x: -180
        }, {
          opacity: 1,
          x: 0
        }).fromTo(rightScreenRef.current, {
          opacity: 0,
          x: 180
        }, {
          opacity: 1,
          x: 0
        }, "-=0.9").fromTo(categoryRef.current, {
          opacity: 0,
          y: -120,
          scale: 0.95
        }, {
          opacity: 1,
          y: 0,
          scale: 1
        }, "-=0.8");
      }, appSectionRef);
      return () => media.revert();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useLayoutEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const media_0 = gsap.matchMedia();
      media_0.add(`${DESKTOP_QUERY} and (prefers-reduced-motion: no-preference)`, () => {
        const tl_0 = gsap.timeline();
        gsap.set(contentRef.current, {
          opacity: 0,
          y: 40
        });
        tl_0.to(contentRef.current, {
          opacity: 1,
          y: 0,
          duration: 0.9,
          delay: 0.5,
          ease: "power3.out"
        });
      }, sectionRef);
      return () => media_0.revert();
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useLayoutEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const media_1 = gsap.matchMedia();
      media_1.add(`${DESKTOP_QUERY} and (prefers-reduced-motion: no-preference)`, () => {
        const tl_1 = gsap.timeline({
          defaults: {
            ease: "power3.out"
          }
        });
        tl_1.fromTo(titleRef.current, {
          opacity: 0,
          y: 40
        }, {
          opacity: 1,
          y: 0,
          duration: 0.7
        });
        tl_1.to({}, {
          duration: 0.4
        });
        tl_1.fromTo(contentRef.current, {
          opacity: 0,
          y: 50
        }, {
          opacity: 1,
          y: 0,
          duration: 0.7
        });
      }, sectionRef);
      return () => media_1.revert();
    };
    t5 = [];
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useLayoutEffect(t4, t5);
  const cardsRef = useRef(null);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      y: 80,
      duration: 1.2,
      stagger: 0.2
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  useGsapStaggerAnimation(cardsRef, t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="pointer-events-none absolute inset-0 -z-10 hidden overflow-hidden dark:block"><div className="absolute left-1/4 top-1/4 h-96 w-96 rounded-full bg-purple-600/20 blur-3xl" /><div className="absolute right-1/4 top-1/3 h-96 w-96 rounded-full bg-blue-600/20 blur-3xl" /></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h1 ref={titleRef} className="leading-tight tracking-tight"><span className="block font-poppins text-[32px] font-medium text-slate-900 dark:text-white sm:text-[40px] lg:text-[56px]">Readymade</span><span className="mt-1 block max-w-sm font-poppins text-[32px] font-extrabold leading-[1.2] text-slate-950 dark:text-white sm:text-[40px] lg:text-[56px]">Grocery App Solution</span></h1>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[9] = desktopAnimations;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 1
    };
    t11 = {
      duration: 1,
      delay: 0.6,
      ease: EASE
    };
    $[11] = t10;
    $[12] = t11;
  } else {
    t10 = $[11];
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t9) {
    t12 = <motion.p initial={t9} animate={t10} transition={t11} className="my-10 max-w-sm font-open-sans text-base font-normal leading-relaxed text-primary dark:text-slate-300 sm:text-lg">Serve Your Customers at Their Doorstep with an On-Demand Grocery Delivery App.</motion.p>;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GradientButton href="/contact" variant="peach-pink" className="mt-10">Contact Us Now<span className="text-xl leading-none transition-transform duration-300 group-hover:translate-x-1">›</span></GradientButton>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== desktopAnimations) {
    t14 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[16] = desktopAnimations;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      opacity: 1
    };
    t16 = {
      duration: 1,
      delay: 0.8,
      ease: EASE
    };
    $[18] = t15;
    $[19] = t16;
  } else {
    t15 = $[18];
    t16 = $[19];
  }
  let t17;
  let t18;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <h2 className="font-poppins text-xl font-semibold leading-7.5 text-slate-800 dark:text-slate-200">Our products are featured on</h2>;
    t18 = <FeaturedCarousel />;
    $[20] = t17;
    $[21] = t18;
  } else {
    t17 = $[20];
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t14) {
    t19 = <motion.div initial={t14} animate={t15} transition={t16} className="mt-10 max-w-md">{t17}{t18}</motion.div>;
    $[22] = t14;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t12 || $[25] !== t19) {
    t20 = <div className="z-10 flex w-full flex-col items-center text-center lg:w-1/2 lg:items-start lg:pt-4 lg:text-left">{t8}{t12}{t13}{t19}</div>;
    $[24] = t12;
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="absolute h-72 w-72 rounded-full bg-blue-100/60 blur-3xl dark:bg-purple-600/20 sm:h-96 sm:w-96 lg:h-128 lg:w-128" />;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div ref={leftScreenRef} className="absolute left-0 top-8 z-10 w-2/3 max-w-md drop-shadow-xl sm:left-4 lg:left-0"><Image src="/images/products/store.png" alt="Grocery Mobile App UI" width={450} height={750} priority={true} className="h-auto w-full object-contain" /></div>;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div ref={rightScreenRef} className="absolute right-10 top-0 z-0 w-2/3 max-w-lg drop-shadow-xl sm:-top-8 sm:right-4 lg:right-5"><Image src="/images/products/veges.png" alt="Grocery Cart UI" width={450} height={750} priority={true} className="h-auto w-full object-contain" /></div>;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="relative flex h-112 w-full max-w-xl items-center justify-center px-4 sm:h-150 lg:h-187 lg:w-1/2">{t21}<div ref={appSectionRef} className="relative h-full w-full">{t22}{t23}<div ref={categoryRef} className="absolute bottom-50 left-0 z-20 w-3/4 max-w-md drop-shadow-xl sm:bottom-40 sm:left-0 lg:bottom-80 lg:-left-30"><Image src="/images/products/fruits.png" alt="Grocery Categories Bar" width={450} height={450} priority={true} className="h-auto w-full object-contain" /></div></div></div>;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== t20) {
    t25 = <section className="relative -mt-20 min-h-screen w-full overflow-hidden bg-white bg-[url('/images/shared/backgrounds/td-bg.jpg')] bg-cover bg-top pt-32 font-sans text-slate-900 transition-colors duration-300 dark:bg-[#050816] dark:bg-none dark:text-white sm:pt-36 lg:pt-44 lg:pt-24">{t7}<div className="relative mx-auto flex max-w-7xl flex-col items-center justify-between gap-12 px-4 sm:px-6 lg:flex-row lg:items-start lg:gap-16 lg:px-12">{t20}{t24}</div></section>;
    $[31] = t20;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <ClientsSection variant="grocery" />;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <div className="mx-auto max-w-3xl text-center"><h2 className="text-3xl font-semibold leading-tight text-[#050748] dark:text-white sm:text-4xl lg:text-5xl">Readymade Grocery Delivery<br />Solution For Every Business</h2><p className="mx-auto mt-5 font-open-sans max-w-3xl text-base leading-7 text-[#7782a6] dark:text-slate-300">Doesn't matter if your business is small or big! We offer different business models based on your needs and let your customers have a smooth shopping experience.</p></div>;
    $[34] = t27;
  } else {
    t27 = $[34];
  }
  let t28;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <section className="bg-gradient-to-b from-[#e9ffff] via-[#f8ffff] to-[#fff6f6] py-20 dark:from-[#0b0f19] dark:via-[#0f1422] dark:to-[#0b0f19]"><div className="mx-auto max-w-7xl px-6 lg:px-12">{t27}<div ref={cardsRef} className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">{businessModels.map(_temp)}</div></div></section>;
    $[35] = t28;
  } else {
    t28 = $[35];
  }
  let t29;
  if ($[36] !== desktopAnimations) {
    t29 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[36] = desktopAnimations;
    $[37] = t29;
  } else {
    t29 = $[37];
  }
  let t30;
  if ($[38] !== desktopAnimations) {
    t30 = desktopAnimations ? {
      opacity: 1
    } : undefined;
    $[38] = desktopAnimations;
    $[39] = t30;
  } else {
    t30 = $[39];
  }
  let t31;
  if ($[40] !== desktopAnimations) {
    t31 = desktopAnimations ? undefined : {
      opacity: 1
    };
    $[40] = desktopAnimations;
    $[41] = t31;
  } else {
    t31 = $[41];
  }
  let t32;
  let t33;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      once: true,
      amount: 0.1
    };
    t33 = {
      duration: 1,
      ease: EASE
    };
    $[42] = t32;
    $[43] = t33;
  } else {
    t32 = $[42];
    t33 = $[43];
  }
  let t34;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Image src="/images/products/product.png" alt="Why Choose Us" width={550} height={550} priority={false} className="h-auto w-full max-w-70 object-contain sm:max-w-95 md:max-w-112.5 lg:max-w-130" />;
    $[44] = t34;
  } else {
    t34 = $[44];
  }
  let t35;
  if ($[45] !== t29 || $[46] !== t30 || $[47] !== t31) {
    t35 = <motion.div initial={t29} whileInView={t30} animate={t31} viewport={t32} transition={t33} className="flex justify-center">{t34}</motion.div>;
    $[45] = t29;
    $[46] = t30;
    $[47] = t31;
    $[48] = t35;
  } else {
    t35 = $[48];
  }
  let t36;
  if ($[49] !== desktopAnimations) {
    t36 = desktopAnimations ? {
      opacity: 0,
      x: 60
    } : false;
    $[49] = desktopAnimations;
    $[50] = t36;
  } else {
    t36 = $[50];
  }
  let t37;
  if ($[51] !== desktopAnimations) {
    t37 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[51] = desktopAnimations;
    $[52] = t37;
  } else {
    t37 = $[52];
  }
  let t38;
  if ($[53] !== desktopAnimations) {
    t38 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[53] = desktopAnimations;
    $[54] = t38;
  } else {
    t38 = $[54];
  }
  let t39;
  let t40;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = {
      once: true,
      amount: 0.1
    };
    t40 = {
      duration: 1,
      ease: EASE
    };
    $[55] = t39;
    $[56] = t40;
  } else {
    t39 = $[55];
    t40 = $[56];
  }
  let t41;
  let t42;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <h2 className="text-3xl font-bold leading-tight text-[#050748] dark:text-white sm:text-4xl lg:text-4xl">Why Choose Us?</h2>;
    t42 = <p className="mx-auto font-open-sans mt-3 max-w-xl text-sm leading-6 text-[#7782a6] dark:text-slate-300 sm:text-base sm:leading-7 lg:mx-0">{"A super easy app & website with a user-friendly interface that helps customers to have flawless shopping throughout."}</p>;
    $[57] = t41;
    $[58] = t42;
  } else {
    t41 = $[57];
    t42 = $[58];
  }
  let t43;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div className="mt-5 flex flex-col items-center space-y-3 lg:items-start"><div className="w-full max-w-80">{features.map(_temp2)}</div></div>;
    $[59] = t43;
  } else {
    t43 = $[59];
  }
  let t44;
  if ($[60] !== t36 || $[61] !== t37 || $[62] !== t38) {
    t44 = <motion.div initial={t36} whileInView={t37} animate={t38} viewport={t39} transition={t40} className="text-center lg:text-left">{t41}{t42}{t43}</motion.div>;
    $[60] = t36;
    $[61] = t37;
    $[62] = t38;
    $[63] = t44;
  } else {
    t44 = $[63];
  }
  let t45;
  if ($[64] !== t35 || $[65] !== t44) {
    t45 = <section className="bg-white py-12 dark:bg-[#0b0f19] sm:py-16 lg:py-20"><div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 sm:px-6 md:grid-cols-2 md:gap-12 lg:gap-16 lg:px-12">{t35}{t44}</div></section>;
    $[64] = t35;
    $[65] = t44;
    $[66] = t45;
  } else {
    t45 = $[66];
  }
  let t46;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <h2 className="mx-auto max-w-3xl text-center text-2xl font-bold leading-snug text-[#050748] transition-colors duration-300 dark:text-white sm:text-3xl lg:text-4xl">{"We build some best online grocery solutions & much more..."}</h2>;
    $[67] = t46;
  } else {
    t46 = $[67];
  }
  let t47;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <>{"Customer Ordering App &"}<br className="hidden sm:inline" /> Website</>;
    $[68] = t47;
  } else {
    t47 = $[68];
  }
  let t48;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <OrderingAppSection contentPosition="left" title={t47} description="A super easy app & website with a user-friendly interface that helps customers to have flawless shopping throughout." features={["OTP based Login & Signup", "Easy Product Search and Filters", "Multilingual Support", "3 Step Checkout", "Time-Slot Booking", "Multiple Payment Options", "Order Tracking"]} images={{
      main: "/images/products/customer-ordering-main.png",
      secondary: "/images/products/customer-ordering-secondary.png",
      circleClassName: "size-63 sm:size-72 md:size-96 lg:size-[600px] bg-[#fff8e6] translate-x-8 sm:translate-x-16 md:translate-x-28 lg:translate-x-36",
      mainClassName: "left-8 top-10 z-10 w-1/2 sm:left-10 sm:top-14 sm:w-3/5 lg:w-80",
      secondaryClassName: "right-0 top-0 z-20 w-1/2 sm:w-3/5 lg:w-96"
    }} />;
    $[69] = t48;
  } else {
    t48 = $[69];
  }
  let t49;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <>Delivery App</>;
    $[70] = t49;
  } else {
    t49 = $[70];
  }
  let t50;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <OrderingAppSection contentPosition="right" title={t49} description="Convenient app for drivers/delivery person to accept and reject orders as per the availability and make the entire process hassle-free." features={["Login via OTP", "GEO Location based delivery", "Push Notifications", "Easy product refund & return", "Profile Making", "Real-time orders", "Transaction History", "Ratings and reviews", "Accept and reject orders"]} images={{
      main: "/images/products/delivery-app-main.png",
      secondary: "/images/products/delivery-app-secondary.png",
      circleClassName: "size-63  sm:-left-22 sm:size-72 md:size-96 lg:size-[600px] bg-[#e9ffff] dark:bg-slate-800 -translate-x-12 sm:-translate-x-20 md:-translate-x-28 lg:-translate-x-32",
      mainClassName: "right-8 top-10 z-10 w-1/2 sm:right-10 sm:w-1/2 lg:w-72",
      secondaryClassName: "left-0 top-1/4 z-20 w-1/2 sm:w-3/5 lg:w-80"
    }} />;
    $[71] = t50;
  } else {
    t50 = $[71];
  }
  let t51;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <>Admin Panel</>;
    $[72] = t51;
  } else {
    t51 = $[72];
  }
  let t52;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <section className="overflow-hidden bg-white py-8 transition-colors duration-300 dark:bg-gray-950 sm:py-14 lg:py-16"><div className="mx-auto flex max-w-7xl flex-col gap-14 px-4 sm:px-6  lg:px-12">{t46}{t48}{t50}<OrderingAppSection contentPosition="left" title={t51} description="A super easy app & website with a user-friendly interface that helps customers to have flawless shopping throughout." features={["Order Management", "Packing Reports and Analytics", "Content Management", "Transaction History", "Single-click price update", "Generate Sub-Admins", "Product Management", "Modification in order after confirmation", "Can allot minimum purchase rates for areas"]} images={{
          main: "/images/products/admin-panel-main.png",
          secondary: "/images/products/admin-panel-secondary.png",
          circleClassName: "size-63 sm:size-72 md:size-96 lg:size-[600px] bg-[#fff8df] dark:bg-slate-800 -translate-y-8 translate-x-3 sm:translate-y-0 sm:translate-x-8 md:translate-x-20 lg:translate-x-32",
          mainClassName: "left-8 top-4 z-10 w-1/2 sm:left-10 sm:top-45 sm:w-3/5 lg:w-96",
          secondaryClassName: "right-0 top-2 z-20 w-1/2 sm:top-24 sm:w-3/5 lg:w-96"
        }} /></div></section>;
    $[73] = t52;
  } else {
    t52 = $[73];
  }
  let t53;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <div className="mx-auto max-w-3xl text-center"><h2 className="text-3xl font-bold leading-tight text-[#050748] dark:text-white sm:text-4xl">We offer everything to spark up your<br />delivery business</h2><p className="mt-3 text-lg font-open-sans text-[#7782a6] dark:text-slate-300">Get your customized product delivered, with our excellent features.</p></div>;
    $[74] = t53;
  } else {
    t53 = $[74];
  }
  let t54;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <section className="bg-[#FFF8F2] py-20 dark:bg-[#121017] transition-colors duration-300"><div className="mx-auto max-w-7xl px-6 lg:px-12">{t53}<div className="mx-auto mt-12 grid w-full max-w-6xl grid-cols-1 items-center justify-center gap-6 sm:grid-cols-2 lg:grid-cols-3">{featureCard.map(_temp3)}</div></div></section>;
    $[75] = t54;
  } else {
    t54 = $[75];
  }
  let t55;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <div className="mx-auto max-w-3xl text-center"><h2 className="text-3xl font-semibold text-[#050748] transition-colors duration-300 dark:text-white sm:text-4xl">Platforms</h2><p className="mt-4 font-open-sans text-lg text-[#7782a6] transition-colors duration-300 dark:text-gray-300">Scalable and flexible multiple vendor platform developed on cutting-edge technology stack.</p></div>;
    $[76] = t55;
  } else {
    t55 = $[76];
  }
  let t56;
  if ($[77] !== desktopAnimations) {
    t56 = desktopAnimations ? {
      opacity: 0,
      x: -60
    } : false;
    $[77] = desktopAnimations;
    $[78] = t56;
  } else {
    t56 = $[78];
  }
  let t57;
  if ($[79] !== desktopAnimations) {
    t57 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[79] = desktopAnimations;
    $[80] = t57;
  } else {
    t57 = $[80];
  }
  let t58;
  if ($[81] !== desktopAnimations) {
    t58 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[81] = desktopAnimations;
    $[82] = t58;
  } else {
    t58 = $[82];
  }
  let t59;
  let t60;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = {
      once: true,
      amount: 0.1
    };
    t60 = {
      duration: 1,
      ease: EASE
    };
    $[83] = t59;
    $[84] = t60;
  } else {
    t59 = $[83];
    t60 = $[84];
  }
  let t61;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <Image src="/images/products/plateform.png" alt="Platforms" width={550} height={450} priority={false} className="h-auto w-full max-w-137.5 object-contain" />;
    $[85] = t61;
  } else {
    t61 = $[85];
  }
  let t62;
  if ($[86] !== t56 || $[87] !== t57 || $[88] !== t58) {
    t62 = <motion.div initial={t56} whileInView={t57} animate={t58} viewport={t59} transition={t60} className="flex justify-center">{t61}</motion.div>;
    $[86] = t56;
    $[87] = t57;
    $[88] = t58;
    $[89] = t62;
  } else {
    t62 = $[89];
  }
  let t63;
  if ($[90] !== desktopAnimations) {
    t63 = platforms.map((item_2, index_1) => <motion.div key={index_1} initial={desktopAnimations ? {
      opacity: 0
    } : false} whileInView={desktopAnimations ? {
      opacity: 1
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.1
    }} transition={{
      duration: 1,
      delay: platformDelays[index_1] || 0,
      ease: EASE
    }} style={{
      backgroundColor: item_2.bg
    }} className="flex h-36 w-full flex-col items-center justify-center rounded-tl-[10px] rounded-tr-[50px] rounded-br-[10px] rounded-bl-[50px] px-4 text-center transition-all duration-300 hover:-translate-y-2 dark:brightness-90 shadow-sm"><Image src={item_2.icon} alt={item_2.title} width={45} height={45} priority={false} className="mb-4 h-11 w-11 object-contain" /><h3 className="whitespace-pre-line text-base font-medium leading-5 text-[#050748] transition-colors duration-300">{item_2.title}</h3></motion.div>);
    $[90] = desktopAnimations;
    $[91] = t63;
  } else {
    t63 = $[91];
  }
  let t64;
  if ($[92] !== t63) {
    t64 = <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-3">{t63}</div>;
    $[92] = t63;
    $[93] = t64;
  } else {
    t64 = $[93];
  }
  let t65;
  if ($[94] !== t62 || $[95] !== t64) {
    t65 = <section className="bg-white py-20 transition-colors duration-300 dark:bg-gray-950"><div className="mx-auto max-w-7xl px-6 lg:px-12">{t55}<div className="mt-16 grid grid-cols-1 items-center gap-12 lg:grid-cols-2">{t62}{t64}</div></div></section>;
    $[94] = t62;
    $[95] = t64;
    $[96] = t65;
  } else {
    t65 = $[96];
  }
  let t66;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <div className="mx-auto max-w-4xl text-center"><h2 className="text-3xl font-bold leading-tight text-[#050748] transition-colors duration-300 dark:text-white sm:text-4xl lg:text-5xl">Pre-Integrated APIs</h2><p className="mx-auto font-open-sans mt-4 max-w-3xl text-sm leading-6 text-[#7782a6] transition-colors duration-300 dark:text-gray-300 sm:mt-5 sm:text-base sm:leading-7 lg:text-lg">Seamless integration with third-party platforms for high-end performance and enhanced user experience. Our multi vendor solutions enable large-scale transformative change with the option of customization to deliver an omnichannel experience across different platforms.</p></div>;
    $[97] = t66;
  } else {
    t66 = $[97];
  }
  let t67;
  if ($[98] !== desktopAnimations) {
    t67 = apiLogos.map((item_3, index_2) => <motion.div key={item_3.name} initial={desktopAnimations ? {
      opacity: 0
    } : false} whileInView={desktopAnimations ? {
      opacity: 1
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.1
    }} transition={{
      duration: 1,
      delay: apiLogoDelays[index_2] || 0,
      ease: EASE
    }} className="flex w-full min-w-0 items-center justify-center"><Image src={item_3.image} alt={item_3.name} width={150} height={150} priority={false} className="h-auto w-full max-w-[90px] object-contain transition duration-300 sm:max-w-[110px] xl:max-w-[125px] dark:brightness-90" /></motion.div>);
    $[98] = desktopAnimations;
    $[99] = t67;
  } else {
    t67 = $[99];
  }
  let t68;
  if ($[100] !== t67) {
    t68 = <section className="bg-gradient-to-b from-[#fffaf8] to-[#f8edff] py-12 transition-colors duration-300 dark:from-gray-950 dark:to-gray-900 sm:py-16 lg:py-24"><div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">{t66}<div className="mt-10 grid w-full grid-cols-2 items-center justify-items-center gap-x-4 gap-y-8 sm:mt-14 sm:grid-cols-4 sm:gap-x-6 sm:gap-y-10 lg:mt-16 xl:grid-cols-8">{t67}</div></div></section>;
    $[100] = t67;
    $[101] = t68;
  } else {
    t68 = $[101];
  }
  let t69;
  if ($[102] !== desktopAnimations) {
    t69 = desktopAnimations ? {
      opacity: 0,
      x: -60
    } : false;
    $[102] = desktopAnimations;
    $[103] = t69;
  } else {
    t69 = $[103];
  }
  let t70;
  if ($[104] !== desktopAnimations) {
    t70 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[104] = desktopAnimations;
    $[105] = t70;
  } else {
    t70 = $[105];
  }
  let t71;
  if ($[106] !== desktopAnimations) {
    t71 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[106] = desktopAnimations;
    $[107] = t71;
  } else {
    t71 = $[107];
  }
  let t72;
  let t73;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = {
      once: true,
      amount: 0.1
    };
    t73 = {
      duration: 1,
      ease: EASE
    };
    $[108] = t72;
    $[109] = t73;
  } else {
    t72 = $[108];
    t73 = $[109];
  }
  let t74;
  let t75;
  let t76;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <span className="text-sm font-open-sans font-medium uppercase tracking-wide text-[#E91C81] sm:text-lg">Delivery App</span>;
    t75 = <h2 className="mx-auto mt-3 max-w-sm text-3xl font-semibold leading-tight text-[#050748] dark:text-white sm:mt-4 sm:text-4xl lg:mx-0">Online Grocery Delivery App Demo</h2>;
    t76 = <p className="mx-auto font-open-sans mt-4 max-w-md text-sm leading-6 text-[#7782a6] dark:text-slate-300 sm:mt-5 sm:text-base sm:leading-7 lg:mx-0 lg:text-lg">Spread your business from offline to online through our custom-built apps. Check us out in the App Store and Google Play.</p>;
    $[110] = t74;
    $[111] = t75;
    $[112] = t76;
  } else {
    t74 = $[110];
    t75 = $[111];
    t76 = $[112];
  }
  let t77;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <GradientButton variant="store-blue" className="h-12 px-6 sm:h-14 sm:px-8"><FaGooglePlay aria-hidden={true} />Google play</GradientButton>;
    $[113] = t77;
  } else {
    t77 = $[113];
  }
  let t78;
  if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
    t78 = <div className="mt-6 flex flex-wrap justify-center gap-3 sm:mt-8 sm:gap-4 lg:justify-start">{t77}<GradientButton variant="store-pink" className="h-12 px-6 sm:h-14 sm:px-8"><FaApple aria-hidden={true} />App Store</GradientButton></div>;
    $[114] = t78;
  } else {
    t78 = $[114];
  }
  let t79;
  if ($[115] !== t69 || $[116] !== t70 || $[117] !== t71) {
    t79 = <motion.div initial={t69} whileInView={t70} animate={t71} viewport={t72} transition={t73} className="text-center lg:text-left">{t74}{t75}{t76}{t78}</motion.div>;
    $[115] = t69;
    $[116] = t70;
    $[117] = t71;
    $[118] = t79;
  } else {
    t79 = $[118];
  }
  let t80;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = <div className="absolute h-65 w-65 rounded-full bg-[#fff1e8] dark:bg-rose-950/20 blur-2xl sm:h-95 sm:w-95 lg:h-120 lg:w-120" />;
    $[119] = t80;
  } else {
    t80 = $[119];
  }
  let t81;
  if ($[120] !== desktopAnimations) {
    t81 = desktopAnimations ? {
      opacity: 0,
      x: 20
    } : false;
    $[120] = desktopAnimations;
    $[121] = t81;
  } else {
    t81 = $[121];
  }
  let t82;
  if ($[122] !== desktopAnimations) {
    t82 = desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined;
    $[122] = desktopAnimations;
    $[123] = t82;
  } else {
    t82 = $[123];
  }
  let t83;
  if ($[124] !== desktopAnimations) {
    t83 = desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    };
    $[124] = desktopAnimations;
    $[125] = t83;
  } else {
    t83 = $[125];
  }
  let t84;
  let t85;
  if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = {
      once: true,
      amount: 0.1
    };
    t85 = {
      duration: 1,
      ease: EASE
    };
    $[126] = t84;
    $[127] = t85;
  } else {
    t84 = $[126];
    t85 = $[127];
  }
  let t86;
  if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
    t86 = <Image src="/images/products/mobile-mockup.png" alt="Online Grocery Delivery App" width={600} height={600} priority={false} className="h-auto w-full object-contain" />;
    $[128] = t86;
  } else {
    t86 = $[128];
  }
  let t87;
  if ($[129] !== t81 || $[130] !== t82 || $[131] !== t83) {
    t87 = <div className="relative flex h-82.5 items-center justify-center sm:h-112.5 lg:h-130">{t80}<motion.div initial={t81} whileInView={t82} animate={t83} viewport={t84} transition={t85} className="relative z-10 w-70 sm:w-105 lg:w-130">{t86}</motion.div></div>;
    $[129] = t81;
    $[130] = t82;
    $[131] = t83;
    $[132] = t87;
  } else {
    t87 = $[132];
  }
  let t88;
  if ($[133] !== t79 || $[134] !== t87) {
    t88 = <section className="bg-white py-12 dark:bg-[#0b0f19] sm:py-16 lg:py-20 transition-colors duration-300"><div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 sm:px-6 md:gap-12 lg:grid-cols-2 lg:gap-16 lg:px-12">{t79}{t87}</div></section>;
    $[133] = t79;
    $[134] = t87;
    $[135] = t88;
  } else {
    t88 = $[135];
  }
  let t89;
  if ($[136] === Symbol.for("react.memo_cache_sentinel")) {
    t89 = <div className="mb-16"><h2 className="w-full max-w-7xl text-center text-xl font-bold tracking-wide text-[#050748] transition-colors duration-300 dark:text-white sm:text-4xl">Our Work Our best Food Delivery Brands developed/ Custom Food Delivery Apps Developed By Us.</h2></div>;
    $[136] = t89;
  } else {
    t89 = $[136];
  }
  let t90;
  let t91;
  if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
    t90 = <section className="w-full bg-white bg-[radial-gradient(#e5e5e5_0.5px,transparent_0.8px)] bg-[size:6px_6px] transition-colors duration-300 dark:bg-gray-950 dark:bg-[radial-gradient(#374151_0.5px,transparent_0.8px)]"><div className="mx-auto w-full max-w-400 px-5 py-14 sm:px-8 sm:py-20 lg:px-10"><div className="mx-auto w-full max-w-300">{t89}<PortfolioStack className="relative flex w-full flex-col gap-8 pb-10">{portfolioProjects.map(_temp4)}</PortfolioStack></div></div></section>;
    t91 = <ContactSection />;
    $[137] = t90;
    $[138] = t91;
  } else {
    t90 = $[137];
    t91 = $[138];
  }
  let t92;
  if ($[139] !== t25 || $[140] !== t45 || $[141] !== t65 || $[142] !== t68 || $[143] !== t88) {
    t92 = <>{t25}{t26}{t28}{t45}{t52}{t54}{t65}{t68}{t88}{t90}{t91}</>;
    $[139] = t25;
    $[140] = t45;
    $[141] = t65;
    $[142] = t68;
    $[143] = t88;
    $[144] = t92;
  } else {
    t92 = $[144];
  }
  return t92;
}
function _temp4(project, index_3) {
  return <PortfolioCard key={project.id} project={project} stackIndex={index_3} stackCount={portfolioProjects.length} />;
}
function _temp3(item_1, index_0) {
  return <FeatureCard key={index_0} icon={item_1.icon} title={item_1.title} description={item_1.description} index={index_0} />;
}
function _temp2(item_0) {
  return <div key={item_0.id} className="flex items-start gap-3 py-1"><div className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#55a8f5] text-white"><FaCheck size={11} /></div><p className="text-left font-open-sans text-sm leading-6 text-[#7782a6] dark:text-slate-300 sm:text-base">{item_0.title}</p></div>;
}
function _temp(item, index) {
  return <BusinessModelCard key={index} icon={item.icon} title={item.title} description={item.description} index={index} />;
}